import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from 'react-redux';
import { api } from '@api/queries/base.ts';
import { ENV } from '@common/app/env';
import { configureStore } from '@reduxjs/toolkit';

import { errorServerMiddleware } from '@/common/middleware/errorServerMiddleware';

import rootReducer from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
  devTools: ENV.IS_DEV,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, errorServerMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default store;
